<template>
    <v-app>
        <router-view></router-view>

        <v-dialog v-model="alertDialogVisible" persistent width="500" scrollable>
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>{{dtitle}}
                    <v-spacer/>
                    <v-icon @click="alertDialogVisible=false">mdi-close</v-icon></v-card-title>
                <v-card-text class="mt-6">
                    <v-row justify="center" align="center">
                        <p style="white-space: pre-wrap;">{{alertMsg}}</p>
                    </v-row>
                </v-card-text>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn id='check321' color="success" @click="alertDialogVisible=false">{{dcheck}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="submit_flag" persistent width="500" scrollable>
            <v-layout align-center justify-center>
                <h2>{{dialog_msg}}</h2>
            </v-layout>
        </v-dialog>
    </v-app>
</template>


<script>
import bus from './components/nav/bus'

// axios.defaults.withCredentials = true;
// axios.defaults.xsrfCookieName = 'csrftoken';
// axios.defaults.xsrfHeaderName = 'X-CSRFToken';

// function randomString(length) {
//     let result = '';
//     let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
//     for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
//     return result;
// }

export default {
    data () {
        return {
            dtitle: "",
            dcheck: "",
            alertMsg: '',
            alertDialogVisible: false,
            submit_flag: false, 
            dialog_msg: '',
        }
    },
    created() {
        // this.$cookies.set("csrftoken", randomString(64), null, null, process.env.VUE_APP_PARENT_HOST); 
    },
    mounted() {
        bus.$off('alert')
        // bus.$off('update')
        // bus.$off('close_update')

        bus.$on('alert', response => {
            this.dtitle = response.title
            this.dcheck = response.check
            this.alertMsg = response.msg
            this.alertDialogVisible = true
        })

        bus.$on('update', response => {
            this.dialog_msg = response.msg
            this.submit_flag = true
        })
        bus.$on('close_update', response => {
            this.submit_flag = false
        })

    },
    methods: {
        // nextPage() {
        //     this.$store.commit('setEditAlert', false)
        //     this.$store.commit('setEditAlertDialog', false)
        //     this.$router.push(this.$store.getters.nextPage)
        // },
        // cancel() {
        //     this.$store.commit('setEditAlertDialog', false)
        // },
    },

    
}
</script>
